import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-dashboard-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './dashboard-info.component.html',
  styleUrl: './dashboard-info.component.css'
})
export class DashboardInfoComponent {
  newUrl: string = '';
  dashboard: any;  // Array to store the list of dashboards
  dashboardId: string | undefined; //Get the dashboardId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the dashboard ID from the route parameters
    this.route.params.subscribe(params => {
      this.dashboardId = params['dashboardId'];  // Workspace ID
      this.newUrl = this.router.url.toString().replace('/dashboard/'+this.dashboardId, '');
    });
    // Fetch the dashboard data when the component initializes
    this.dataFetcher.GetDashboardByIdData(this.dashboardId).subscribe(
      (data: any) => {
        // Extract the 'dashboards' array from the data object
        this.dashboard = data.dashboards[0] || null;  // Fallback to an empty array if 'dashboards' is undefined
      },
      (error) => {
        console.error('Error fetching dashboard data', error);
      }
    );
    console.log(this.dashboard);
  }
}

